module.exports = __webpack_public_path__ + "img/medical_group_manager.fcf44c07.png";